import Consult from ".";

export const consultRoutes = [
  {
    path: "/consult",
    element: <Consult />,
  },
];
